
import { Component, Vue, Prop } from "vue-property-decorator";
import { Toast } from "vant";
import dayjs from "dayjs";
import { EmployerActivityService } from "src/services";

@Component
export default class CouponOnePage extends Vue
{

    /**
     * 父组件传值
     * @private
     * @returns object
     */
    @Prop({type: Number, default: 1})
    private column: 1;

    @Prop({type: Number, default: 4})
    private styleType: 1;

    @Prop({type: Array, default: []})
    private couponList: [];

    /**
     * 优惠券类型映射
     * @private
     * @returns Object
     */
    private couponTypeMap: any = {
        fullReduce: 2,
        discount: 4,
    };

    /**
     * 优惠券状态map
     * @private
     * @returns object
     */
    private couponStatusMap: any = {
        unprogress: 2,  // 未开始
        progressing: 4, // 进行中
        finished: 6,    // 已结束
        invalid: 8,     // 已失效
        disable: 10     // 已禁用
    }

    /**
     * loading
     * @private
     * @returns boolean
     */
    private loading: boolean = false;

    /**
     * 领取/继续领
     * @private
     * @returns void
     */
    private async onReceive(data: any): Promise<any>
    {
        try
        {
            if (this.onLogin())
            {
                return;
            }
            if (this.loading) {
                return;
            }
            this.loading = true;
            // 不加密
            let isEncryption = false;
            let { content: result } = await EmployerActivityService.instance.couponReceive(data.id, isEncryption);
            Toast('领取成功');
            this.$emit('getCouponListPage');
        }
        catch(err)
        {
            Toast(err);
        }
        finally {
            this.loading = false;
        }
    }

    /**
     * 跳转优惠券管理页面
     * @private
     * @returns void
     */
    private onToUse(item:any): void
    {
        this.$router.push({name: 'coupon-list-manage'});
    }

    /**
     * 跳转优惠券领取详情
     * @private
     * @returns void
     */
    private onToDetail(item:any): void
    {
        this.$router.push({name: 'coupon-list-info', query:{cid: item.id, from: 'home'}});
    }

    /**
     * 判断是否登入
     * @private
     * @returns void
     */
    private onLogin(): boolean
    {
        if (!localStorage.getItem("userInfo"))
        {
            this.$router.push({name:"login", query:{redirect: location.href}});
            return true;
        }
    }
}
